import { hasAdminPermission } from './adminPermissions';

export const canManageUnitImport = (user) => hasAdminPermission(user, 'edit_units');
